document.addEventListener('turbolinks:load', () => {
    // --- 1. Remove Stock Inquiry 機能 ---
    document.querySelectorAll('.remove-stock-inquiry').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const container = button.closest('.stock-inquiry-item');
        const destroyField = container.querySelector('.destroy-flag');
        const stockIdField = container.querySelector('input[name*="[stock_id]"]');
        const stockId = stockIdField ? stockIdField.value : null;

        if (stockId) {
          fetch(`/stock_inquiry_carts/remove_stock/${stockId}`, {
            method: 'DELETE',
            headers: {
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
              'Accept': 'application/json'
            }
          }).then(response => {
            if (response.ok) {
              destroyField.value = '1';
              container.remove();

              // ヘッダーのカート表示を更新
              const remainingItems = document.querySelectorAll('.stock-inquiry-item').length;
              const cartBadge = document.querySelector('.cart-item .badge');
              
              if (cartBadge) {
                if (remainingItems > 0) {
                  cartBadge.textContent = remainingItems;
                } else {
                  cartBadge.remove();
                  document.querySelector('.cart-item').classList.remove('blink');
                }
              }

              // 空のメッセージ表示の既存処理
              if (remainingItems === 0) {
                const containerDiv = document.querySelector('.container');
                const emptyMessage = containerDiv.getAttribute('data-empty-message');
                containerDiv.innerHTML = `<p>${emptyMessage}</p>`;
              }
            } else {
              console.error('Failed to remove stock from session');
            }
          }).catch(error => {
            console.error(error);
          });
        }
      });
    });
  
    // --- 2. チェックボックスの連動機能 ---    
    const mainCheckboxes = document.querySelectorAll('.main-stock-inquiry-checkbox');
    const stockInquiryCheckboxes = document.querySelectorAll('.stock-inquiry-checkbox');

    mainCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const selectedValues = Array.from(mainCheckboxes)
          .filter(cb => cb.checked)
          .map(cb => cb.value);

        stockInquiryCheckboxes.forEach(cb => {
          cb.checked = selectedValues.includes(cb.value);
        });
      });
    });
  });
  